export const CAR_TRAWLER_SCRIPT_ELEMENT_ID = "swa-ct-smartblock-loader-script";
export const CAR_TRAWLER_SECTION_ID = "swa-smartblock";
